import { createApp } from 'vue'
import './assets/css/style.scss'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'mdi/css/materialdesignicons.css'
import { createPinia } from 'pinia';
const vuetify = createVuetify({
    components,
    directives,
})
const pinia = createPinia();
import App from './App.vue'
import router from './router'
import store from './store'
import registerPlugins from './plugins'
const app = createApp(App);
app.config.devtools = false;
registerPlugins(app)
app.use(pinia).use(router).use(store).use(vuetify).mount('#app')
